// extracted by mini-css-extract-plugin
export default {"addressSection":"hV-z","disabled":"iV-z","sectionButtons":"jV-z","logo":"kV-z"};